import { HttpService } from '@/infra/http'

export class GetSimulacaoPdfService extends HttpService {
  execute = async (simulacaoId: string) => {
    return this.http.get<Blob>(`api/v2/Simulacao/pdf/${simulacaoId}`, {
      responseType: 'blob',
    })
  }
}
